"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadAttachToS3 = void 0;
const core_1 = require("@apitable/core");
const axios_1 = __importDefault(require("axios"));
function getCertificate(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield core_1.Api.getUploadCertificate(params);
        const { data, success } = res.data;
        if (!success) {
            return res.data;
        }
        return data;
    });
}
function uploadDirectOSS(uploadCertificate, file, axiosConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        const requestMethod = String(uploadCertificate.uploadRequestMethod).toLowerCase();
        yield (0, axios_1.default)(Object.assign({ url: convertOrigin(uploadCertificate.uploadUrl), method: requestMethod, data: file }, axiosConfig));
    });
}
/**
 * Private deployments use minio and need to replace the data in origin according to the current environment.
 */
function convertOrigin(url) {
    const _url = new URL(url);
    if (/http:\/\/minio/.test(_url.origin)) {
        return `${location.origin}${_url.pathname}${_url.search}`;
    }
    return url;
}
function notify(uploadCertificate, type) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield core_1.Api.getS3Callback({
            resourceKeys: [uploadCertificate.token],
            type
        });
        const { data } = res.data;
        return {
            data: Object.assign(Object.assign({}, res.data), { data: Array.isArray(data) ? data[0] : data })
        };
    });
}
function uploadAttachToS3(optional) {
    return __awaiter(this, void 0, void 0, function* () {
        const { nodeId, fileType, file, axiosConfig, data = '' } = optional;
        const _fileType = file.type;
        if (_fileType === 'text/html') {
            return;
        }
        const uploadCertificates = yield getCertificate({ count: 1, type: fileType, data, nodeId });
        if (!Array.isArray(uploadCertificates)) {
            // If you get an error when getting a pre-signature, return the pre-signed error message directly.
            return uploadCertificates;
        }
        yield uploadDirectOSS(uploadCertificates[0], file, Object.assign(Object.assign({}, axiosConfig), { headers: { 'Content-Type': _fileType } }));
        return notify(uploadCertificates[0], fileType);
    });
}
exports.uploadAttachToS3 = uploadAttachToS3;
